export enum StaffType {
  ADMIN = 0,
  MANAGER = 1,
  CASHIER = 2,
  WAITER = 3,
}

export namespace StaffType {
  export function getName(type: StaffType): string {
    switch (type) {
      case StaffType.ADMIN:
        return 'ENUM.STAFF_TYPE.ADMIN';
      case StaffType.MANAGER:
        return 'ENUM.STAFF_TYPE.MANAGER';
      case StaffType.CASHIER:
        return 'ENUM.STAFF_TYPE.CASHIER';
      case StaffType.WAITER:
        return 'ENUM.STAFF_TYPE.WAITER';
      default:
        return 'ENUM.STAFF_TYPE.UNKNOWN';
    }
  }
}
